"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Close = function Close(props) {
  return react_1.default.createElement("svg", __assign({
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "currentColor"
  }, props), react_1.default.createElement("path", {
    d: "M7.58 6.5l5.2-5.19a.79.79 0 000-1.09.79.79 0 00-1.09 0L6.5 5.42 1.31.22a.79.79 0 00-1.09 0 .79.79 0 000 1.09l5.2 5.19-5.2 5.19a.79.79 0 000 1.09.77.77 0 00.55.22.76.76 0 00.54-.22l5.19-5.2 5.19 5.2a.79.79 0 001.09 0 .79.79 0 000-1.09z"
  }));
};

exports.default = Close;